<template>
  <div class="login-screen-wrapper">
    <v-card class="my-5">
      <div v-if="tenantId" class="headline" style="padding-top: 20px">
        {{tenantId}}
      </div>
      <v-card-title>
        <div class="headline">
           Team Login
        </div>
      </v-card-title>
      <v-card-text>
        <v-flex xs10>
          <v-select
            prepend-icon="games"
            :items="games"
            v-model="gameId"
            label="Game"
            single-line
            item-text="gameName"
            item-value="idGame"
            autocomplete
          ></v-select>

          <v-select
            prepend-icon="person"
            :items="teams"
            v-model="teamName"
            label="Team name"
            single-line
            item-text="teamName"
            item-value="teamName"
            autocomplete
            :error="error"
          ></v-select>

          <v-text-field
            label="Password"
            prepend-icon="lock"
            v-model="password"
            type="password"
            :error="error"
          ></v-text-field>
          <v-alert error value="true" v-if="error">
            {{errorMessage}}
          </v-alert>
        </v-flex>
      </v-card-text>
      <v-card-actions class="ml-2 mt-3">
        <v-btn primary @click.native="login()">
          Login
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
  import VueMarkdown from 'vue-markdown'
  import {mapActions} from 'vuex'
  import {teamLogin, getTeamsByGameId} from '../services/teamService'
  import {getGames} from '../services/gameService'

  const actions = mapActions([
    'loginTeam',
  ])

  export default {
    name: 'login',
    components: {
      VueMarkdown,
    },
    data() {
      return {
        tenantId: '',

        gameId: '',
        games: [],
        teams: [],
        teamName: '',
        password: '',
        error: false,
        errorMessage: '',
      }
    },
    async created() {
      this.tenantId = this.$route.params.tenantId
      try {
        const serverGames = await getGames(this.tenantId)
        this.games = serverGames.data.filter((game) => {
          return game.gameStatus !== 'stopped'
        })
      } catch (err) {
        console.log(err)
        this.games = []
      }
    },
    watch: {
      async gameId() {
        await getTeamsByGameId(this.gameId)
          .then((teams) => {
            this.teams = teams
          })
          .catch((err) => {
            console.log(err)
            this.teams = []
          })
      },
    },
    methods: {
      ...actions,
      login() {
        this.clearErrorMessage()

        const credentials = {
          gameId: this.gameId,
          teamName: this.teamName,
          password: this.password + '',
        }
        teamLogin(credentials, this.$store.state.fingerprint)
        .then((loginDetails) => {
          this.loginTeam(loginDetails)
        })
        .then(() => {
          this.$emit('loginSuccess')
          this.$router.push({name: 'Home'})
        })
        .catch((error) => {
          console.error(error)
          if (error.response && error.response.status === 401) {
            this.errorMessage = error.response.data.message
          } else {
            this.errorMessage = 'Sorry we are unable to serve your request :('
          }
          this.error = true
        })
      },
      clearErrorMessage() {
        this.errorMessage = ''
        this.error = false
      }
    },
  }
</script>

<style lang="scss" type="text/scss" scoped>

  .login-screen-wrapper {
    background-color: #fafafa;
  }

  .card {
    max-width: 500px;
    padding-bottom: 20px;
    padding-left: 20px;

    /deep/ {

      .card__text {
        padding-top: 0;
        padding-bottom: 0;

        .question-wrapper {
          text-align: left;

          p {
            font-size: 18px;
          }
        }

        .input-group--text-field {
          margin: 0 0 18px 0;
        }
      }

      .input-group__details {
        min-height: 2px;
      }

      .card__actions .fa-chevron-left {
        font-size: 1.2rem;
        margin-right: 10px;
      }
    }
  }

  .card {
    margin: auto;
  }

  @media screen and (max-width: 548px) {
    .card {
      margin: 28px;
    }
  }

  .overlay {
    position: relative;
  }

  .overlay:after {
    position: absolute;
    content: "";
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
  }

  .dialog .sign-in-wrapper {
    margin-right: 15px;
  }

  @keyframes fadeIn {
    0% {
      opacity: 0.0;
    }
    100% {
      opacity: 1.0;
    }
  }


</style>




// WEBPACK FOOTER //
// src/components/TeamLogin.vue